module.exports = __webpack_public_path__ + "static/media/react-brands-color.cca72302.svg";